import cx from 'classnames';
import type {FC, RefObject} from 'react';
import {Button} from '~library/atoms/Button';
import {DiamondIcon} from '~library/svg/DiamondIcon';

import './EditButton.sass';

interface EditButtonProps {
  'data-qa-id': string;
  ref?: RefObject<HTMLButtonElement | null> | ((instance: HTMLButtonElement) => void);
  onClick?: () => void;
  text?: string;
  showPremiumIcon?: boolean;
  hide?: boolean;
  isStatic?: boolean; // if true, button is always visible
}

export const EditButton: FC<EditButtonProps> = ({
  'data-qa-id': qaId,
  ref,
  onClick,
  text = 'Edit',
  showPremiumIcon = false,
  hide = false,
  isStatic = false,
}) =>
  hide ? null : (
    <Button
      variant="unstyled-button"
      id={qaId}
      data-qa-id={qaId}
      className={cx('view-invitation__edit-feature-button', {'force-visible': isStatic})}
      ref={ref}
      onClick={onClick}
    >
      {showPremiumIcon && <DiamondIcon ratio={1.1} />}
      {text}
    </Button>
  );
